import {
  Popover,
  PopoverContent,
  HStack,
  IconButton,
  ListItem,
  UnorderedList,
  Tooltip,
  Box,
  Text,
  Icon,
} from "@chakra-ui/react";
import { GrDownload } from "react-icons/gr";
import { FaMoneyBillWave } from "react-icons/fa";
import GarrazCopyText from "./GaraazCopyText";
import React, { useCallback } from "react";
import { downloadInvoiceForOrder } from "../orderUtils";
import { useGetAllSuppliers } from "../queryHooks";
import { GaraazCopyText } from "@svan-garaaz/reactsharedlib";

type InvoicePopoverProps = {
  children?: React.ReactNode;
  Invoices: any[];
  copierKeys: any[];
  Challans: any[];
  CreditNotes?: any[];
};

const InvoicePopver: React.FC<InvoicePopoverProps> = ({
  Invoices,
  children,
  copierKeys,
  Challans,
  CreditNotes,
}) => {
  const { data: allSuppliers } = useGetAllSuppliers();
  const getTitleCaseFromCamelCase = (word: string) => {
    const result = word.replace(/([A-Z])/g, " $1");
    const formatted = result.charAt(0).toUpperCase() + result.slice(1);
    return formatted.replace("Credit Note", "CN");
  };

  const getSupplierBusinessName = useCallback(
    (supplierId: string) => {
      const supplier = allSuppliers?.find(
        (supplier: any) => supplier._id === supplierId,
      );
      return supplier ? supplier.businessName : "";
    },
    [allSuppliers, Invoices],
  );

  const excludedKeys = [
    "title",
    "invoiceMediaId",
    "mrpInvoiceMediaId",
    "supplierId",
    "challanMediaId",
    "creditNoteMediaId",
    "paymentLink",
  ];

  return (
    <Popover returnFocusOnClose={false} trigger="hover">
      {children}

      <PopoverContent style={{ padding: "10px", height: "100%" }}>
        {Invoices?.some((item) => item?.invoiceNo) && (
          <>
            <HStack justifyContent={"space-between"} mb="2">
              <Text color={"#4A5567"} fontSize={"lg"} fontWeight={"bold"}>
                Invoice Info
              </Text>
            </HStack>

            <Box textColor={"#4A5567"}>
              <UnorderedList fontSize={"sm"}>
                {Invoices?.map((item: any, index: number) =>
                  item?.invoiceNo ? (
                    <ListItem key={index}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                        gap={1}
                      >
                        <Text fontWeight="bold">
                          {item?.title ??
                            `${getSupplierBusinessName(item?.supplierId)}`}
                        </Text>
                        <HStack spacing={1} flexShrink={0}>
                          {item?.paymentLink && (
                            <Tooltip label="Copy payment link" placement="top">
                              <Box
                                display="inline-flex"
                                alignItems="center"
                                justifyContent="center"
                                cursor="pointer"
                                color="teal.600"
                                _hover={{ color: "teal.700" }}
                              >
                                <GaraazCopyText
                                  text={item.paymentLink}
                                  popOverMessage="Payment link copied"
                                  key={item.paymentLink}
                                  icon={<FaMoneyBillWave />}
                                />
                              </Box>
                            </Tooltip>
                          )}

                          <Tooltip label="Download Invoice" placement="top">
                            <IconButton
                              icon={<GrDownload />}
                              onClick={() => {
                                downloadInvoiceForOrder(item?.invoiceMediaId);
                              }}
                              aria-label="download Invoice"
                              size="xs"
                              bg="none"
                            />
                          </Tooltip>
                            {item?.mrpInvoiceMediaId &&
                            (item?.title === "Garaaz" || !item?.supplierId) && (
                              <Tooltip
                                label="Download MRP Invoice"
                                placement="top"
                              >
                                <IconButton
                                  icon={<GrDownload />}
                                  onClick={() => {
                                    downloadInvoiceForOrder(
                                      item?.mrpInvoiceMediaId,
                                    );
                                  }}
                                  aria-label="download MRP Invoice"
                                  size="xs"
                                  bg="green.100"
                                />
                              </Tooltip>
                            )}
                        </HStack>
                      </Box>

                      <UnorderedList
                        key={index}
                        listStyleType={"none"}
                        marginLeft={0}
                        marginBottom={"1em"}
                      >
                        {Object?.entries(item)?.map(
                          ([key, value]: [any, any], index) => {
                            return !excludedKeys.includes(key) ? (
                              <ListItem
                                display={"flex"}
                                key={index}
                                alignItems={"center"}
                              >
                                <>
                                  {" "}
                                  <Text fontSize={"sm"} minWidth={"90px"}>
                                    {getTitleCaseFromCamelCase(key)}
                                  </Text>
                                  <Text fontSize={"sm"} marginRight={"5px"}>
                                    :
                                  </Text>{" "}
                                </>

                                <Tooltip label={`${value}`}>
                                  <Text
                                    fontSize={"sm"}
                                    noOfLines={1}
                                  >{`${value}`}</Text>
                                </Tooltip>
                                {copierKeys.includes(key) && (
                                  <GarrazCopyText
                                    text={value}
                                    popOverMessage={`${key} Copied`}
                                  ></GarrazCopyText>
                                )}
                              </ListItem>
                            ) : (
                              <React.Fragment key={index} />
                            );
                          },
                        )}
                      </UnorderedList>
                    </ListItem>
                  ) : (
                    <React.Fragment key={index} />
                  ),
                )}
              </UnorderedList>
            </Box>
          </>
        )}
        {Challans?.some((item) => item?.challanNo) && (
          <>
            <HStack justifyContent={"space-between"} mb="2">
              <Text color={"#4A5567"} fontSize={"lg"} fontWeight={"bold"}>
                Challan Info
              </Text>
            </HStack>
            <Box textColor={"#4A5567"}>
              <UnorderedList fontSize={"sm"}>
                {Challans?.map((item: any, index: number) =>
                  item?.challanNo ? (
                    <ListItem key={index}>
                      <Box display={"flex"} justifyContent={"space-between"}>
                        {" "}
                        <Text fontWeight={"bold"}>
                          {item?.title ??
                            `${getSupplierBusinessName(item?.supplierId)}`}
                        </Text>
                        <IconButton
                          icon={<GrDownload />}
                          onClick={() => {
                            downloadInvoiceForOrder(item?.challanMediaId);
                          }}
                          aria-label="download"
                          size={"xs"}
                          bg={"none"}
                        />{" "}
                      </Box>

                      <UnorderedList
                        key={index}
                        listStyleType={"none"}
                        marginLeft={0}
                        marginBottom={"1em"}
                      >
                        {Object?.entries(item)?.map(
                          ([key, value]: [any, any], index) => {
                            return !excludedKeys.includes(key) ? (
                              <ListItem
                                display={"flex"}
                                key={index}
                                alignItems={"center"}
                              >
                                <>
                                  {" "}
                                  <Text fontSize={"sm"} minWidth={"90px"}>
                                    {getTitleCaseFromCamelCase(key)}
                                  </Text>
                                  <Text fontSize={"sm"} marginRight={"5px"}>
                                    :
                                  </Text>{" "}
                                </>

                                <Tooltip label={`${value}`}>
                                  <Text
                                    fontSize={"sm"}
                                    noOfLines={1}
                                  >{`${value}`}</Text>
                                </Tooltip>
                                {copierKeys.includes(key) && (
                                  <GarrazCopyText
                                    text={value}
                                    popOverMessage={`${key} Copied`}
                                  ></GarrazCopyText>
                                )}
                              </ListItem>
                            ) : (
                              <React.Fragment key={index} />
                            );
                          },
                        )}
                      </UnorderedList>
                    </ListItem>
                  ) : (
                    <React.Fragment key={index} />
                  ),
                )}
              </UnorderedList>
            </Box>
          </>
        )}
        {CreditNotes?.some((item) => item?.creditNoteNo) && (
          <>
            <HStack justifyContent={"space-between"} mb="2">
              <Text color={"#4A5567"} fontSize={"lg"} fontWeight={"bold"}>
                Credit Note Info
              </Text>
            </HStack>
            <Box textColor={"#4A5567"}>
              <UnorderedList fontSize={"sm"}>
                {CreditNotes?.map((item: any, index: number) =>
                  item?.creditNoteNo ? (
                    <ListItem key={index}>
                      <Box display={"flex"} justifyContent={"space-between"}>
                        {" "}
                        <Text fontWeight={"bold"}>
                          {item?.title ?? "Garaaz"}
                        </Text>
                        <IconButton
                          icon={<GrDownload />}
                          onClick={() => {
                            downloadInvoiceForOrder(item?.creditNoteMediaId);
                          }}
                          aria-label="download"
                          size={"xs"}
                          bg={"none"}
                        />{" "}
                      </Box>

                      <UnorderedList
                        key={index}
                        listStyleType={"none"}
                        marginLeft={0}
                        marginBottom={"1em"}
                      >
                        {Object?.entries(item)?.map(
                          ([key, value]: [any, any], index) => {
                            return !excludedKeys.includes(key) ? (
                              <ListItem
                                display={"flex"}
                                key={index}
                                alignItems={"center"}
                              >
                                <>
                                  {" "}
                                  <Text fontSize={"sm"} minWidth={"90px"}>
                                    {getTitleCaseFromCamelCase(key)}
                                  </Text>
                                  <Text fontSize={"sm"} marginRight={"5px"}>
                                    :
                                  </Text>{" "}
                                </>

                                <Tooltip label={`${value}`}>
                                  <Text
                                    fontSize={"sm"}
                                    noOfLines={1}
                                  >{`${value}`}</Text>
                                </Tooltip>
                                {copierKeys.includes(key) && (
                                  <GarrazCopyText
                                    text={value}
                                    popOverMessage={`${key} Copied`}
                                  ></GarrazCopyText>
                                )}
                              </ListItem>
                            ) : (
                              <React.Fragment key={index} />
                            );
                          },
                        )}
                      </UnorderedList>
                    </ListItem>
                  ) : (
                    <React.Fragment key={index} />
                  ),
                )}
              </UnorderedList>
            </Box>
          </>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default InvoicePopver;
